export enum SystemRole {
	ADMIN = 'Super admin',
	TAC = 'TAC',
	MC = 'MC',
	ES = 'ES',
	EXPERT = 'Expert',
	BOARD_MEMBER = 'Board member',
	DIRECTOR = 'Director',
}
